export type FacetedTag = {
  entityType: string;
  name: string;
};

export type FacetedTagOption = {
  $group: string;
  key: string;
  label: string;
  value: string[];
};

export function formatTagsToFaceted(tags: FacetedTag[]): FacetedTagOption[] {
  return tags.reduce<FacetedTagOption[]>((result, item) => {
    const index = result.findIndex((entry) => entry.label === item.entityType);

    if (index === -1) {
      result.push({
        $group: 'nogroup',
        // $group: item.entityType,
        key: item.entityType.toLowerCase(),
        label: item.entityType,
        value: [item.name],
      });
    } else {
      result[index].value.push(item.name);
    }

    return result;
  }, []);
}
